export default {
  RegularFund: 1, // kinh phí thường xuyên
  IrregularFund: 2 // kinh phí không thường xuyên
};
